import { SnailTrailSegment, SnailTrailModel } from './../models/snail-trail.model';
import { OnInit, OnDestroy, Component, Input, Output, EventEmitter } from '@angular/core';

declare var google: any;

@Component({
  selector: 'wego-snail-trail-map',
  template: require('../views/snail-trail-map.component.html'),
  styles: [`
      #map {
          height: 1100px;
      }
  `]
})
export class SnailTrailMapComponent implements OnInit, OnDestroy {
  currentTrip: SnailTrailModel;
  currentSegment: SnailTrailSegment;
  map: any;
  listOfPolyline: any = [];
  listOfPolylineCoordinate: any = [];
  highlightedPolyline: any;

  @Output('OnSegmentChange') onSegmentChange = new EventEmitter();

  // Input from the parent component
  @Input('CurrentTrip')
  set CurrentTrip(currentTrip: any) {
    this.currentTrip = currentTrip;
    setTimeout(()=> {
      this.ResizeMap();
      this.DrawPolyline();
    });
  }
  get CurrentTrip() {
    return this.currentTrip;
  }

  // Input from the parent component
  @Input('CurrentSegment')
  set CurrentSegment(currentSegment: any) {
    this.currentSegment = currentSegment;
    setTimeout(()=> {
      this.ResizeMap();
      this.HighlightPolyline();
    });
  }
  get CurrentSegment() {
    return this.currentSegment;
  }

  ngOnInit(): void {
    this.InitMap();
  }

  InitMap() {
    this.listOfPolyline = [];
    this.listOfPolylineCoordinate = [];
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: 52.3702164, lng: 4.895168 },
      zoom: 13,
    });
  }

  DrawPolyline() {
    this.RemovePolyline();
    if (this.currentTrip) {
      let listOfSegment = this.currentTrip.snailTrailSegment;

      if (listOfSegment && listOfSegment.length > 0) {
        for (let i = 0; i < listOfSegment.length; i++) {
          let segmentDetail = listOfSegment[i];
          if (segmentDetail.startLocation.latitude && segmentDetail.startLocation.longitude
            && segmentDetail.endLocation.latitude && segmentDetail.endLocation.longitude) {

            let segmentCoordinates: any = [
              { lat: segmentDetail.startLocation.latitude, lng: segmentDetail.startLocation.longitude },
              { lat: segmentDetail.endLocation.latitude, lng: segmentDetail.endLocation.longitude }
            ];

            let arrowIcon: any = [];
            if (i == 0) {
              let arrowSymbol = {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                fillColor: '#FF0000',
                fillOpacity: 0.4,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8
              };

              arrowIcon.push({
                icon: arrowSymbol,
                offset: '0%'
              });
            }

            let segmentPath = new google.maps.Polyline({
              path: segmentCoordinates,
              geodesic: true,
              strokeColor: '#000000',
              strokeOpacity: 0.4,
              strokeWeight: 5,
              zIndex: 1,
              icons: arrowIcon
            });

            segmentPath.setMap(this.map);

            google.maps.event.addListener(segmentPath, 'click', () => this.HandleSegmentClick(i));

            this.listOfPolyline.push(segmentPath);

            this.listOfPolylineCoordinate.push({ lat: segmentDetail.startLocation.latitude, lng: segmentDetail.startLocation.longitude },
              { lat: segmentDetail.endLocation.latitude, lng: segmentDetail.endLocation.longitude });
          }
        }
      }
    }
    this.FitPolylineToBound();
  }

  RemovePolyline() {
    if (this.listOfPolyline) {
      while (this.listOfPolyline.length) {
        this.listOfPolyline.pop().setMap(null);
      }
    }
    this.listOfPolylineCoordinate = [];
    this.RemoveHighlightPolyline();
  }

  HighlightPolyline() {
    this.RemoveHighlightPolyline();
    if (this.currentSegment) {
      if (this.currentSegment.startLocation.latitude && this.currentSegment.startLocation.longitude
        && this.currentSegment.endLocation.latitude && this.currentSegment.endLocation.longitude) {

        let segmentCoordinates: any = [
          { lat: this.currentSegment.startLocation.latitude, lng: this.currentSegment.startLocation.longitude },
          { lat: this.currentSegment.endLocation.latitude, lng: this.currentSegment.endLocation.longitude }
        ];

        this.highlightedPolyline = new google.maps.Polyline({
          path: segmentCoordinates,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 1,
          strokeWeight: 10,
          zIndex: 2
        });

        this.highlightedPolyline.setMap(this.map);
      }
    }
  }

  RemoveHighlightPolyline() {
    if (this.highlightedPolyline) {
      this.highlightedPolyline.setMap(null);
    }
  }

  HandleSegmentClick(segmentPosition: number) {
    this.onSegmentChange.emit({ position: segmentPosition });
  }

  ResizeMap() {
    //setTimeout(() => {
      // let center = this.map.getCenter();
      google.maps.event.trigger(this.map, "resize");
      // this.map.setCenter(center);
    //});
  }

  FitPolylineToBound() {
    if (this.listOfPolylineCoordinate && this.listOfPolylineCoordinate.length > 0) {
      let bound = new google.maps.LatLngBounds();
      for (var i in this.listOfPolylineCoordinate) {
        bound.extend(this.listOfPolylineCoordinate[i]);
      }
      if (this.map) {
        this.map.fitBounds(bound);
      }
    }
  }

  ngOnDestroy(): void {

  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail/components/snail-trail-map.component.ts